import React, { FC } from 'react';
import { getExtension } from '../../../../../../utils/path';
import { ListFileThumbnailLabel } from '../ListFileThumbnailLabel';
import styles from '../ListFileThumbnail.scss';
import { IFileThumbnail } from '../../../../../common/Thumbnails/types';

export const Labeled: FC<IFileThumbnail> = ({ file, className, dataHook }) => (
  <div className={className} data-hook={dataHook}>
    <ListFileThumbnailLabel className={styles.label} label={`.${getExtension(file.fileUrl)}`} />
  </div>
);
